import { createFileRoute } from "@tanstack/react-router"

import { seoMeta } from "@/lib/seo"

import { RebellionBenefits } from "./-components/RebellionBenefits"
import { RebellionSignupSection } from "./-components/RebellionSignupSection"
import { fetchRebellionFields } from "./-data/rebellion-form"
import { rebellionMeta } from "./-data/rebellion-meta"

export const Route = createFileRoute("/_content/rebellion/")({
  head: () => seoMeta(rebellionMeta),
  // Fields are fetched server-side from HubSpot so edits in HubSpot are
  // reflected without a redeploy. This route is excluded from prerender
  // (see vite.config.ts) so the loader runs per request.
  loader: async () => ({ fields: await fetchRebellionFields() }),
  component: RebellionPage,
})

function RebellionPage() {
  const { fields } = Route.useLoaderData()

  return (
    <>
      <RebellionSignupSection fields={fields} />
      <RebellionBenefits />
    </>
  )
}
